export const isArrayBlank = (arr) => {
  return !arr || false || arr.length === 0 || arr.every((item) => item === '');
};

export const isArrayNotBlank = (arr) => {
  return !isArrayBlank(arr);
};

/**
 * Check if two arrays are equal
 * @param arr1
 * @param arr2
 * @returns {boolean}
 */
export const arraysEqual = (arr1, arr2) => {
  return JSON.stringify(arr1) === JSON.stringify(arr2);
};

/**
 * 是否包含重复属性的对象
 * @param array
 * @returns {*}
 */
export const hasDuplicateProperties = (array) => {
  const seenProperties = new Set();

  return array.some((item) => {
    const itemProperties = Object.keys(item)
      .map((key) => `${key}:${item[key]}`)
      .join(',');
    if (seenProperties.has(itemProperties)) {
      return true;
    }
    seenProperties.add(itemProperties);
    return false;
  });
};
